export const SIGNUP_LAUNCHDARKLY_EVENTS = {
  LANDING_PAGE_EXPERIMENT: {
    TRIGGERED: 'show_landing_page',
    SUBMITTED_EVALUATION: {
      ATTEMPT: 'evaluation_schedule_attempt',
      SUCCESS: 'evaluation_schedule_success',
      FAILURE: 'evaluation_schedule_failure',
    },
  },
};
